import axios from 'axios';
import { path_to_site } from './axios_settings';
import { handleNetworkError } from '../utils/networkErrorHandler';

// Функция для проверки промо-кода
export const checkPromoCode = async (code) => {
  try {
    const formData = new FormData();
    formData.append('request', 'check_promo_code');
    formData.append('code', code);

    const response = await axios.post(path_to_site, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    // console.log('PromoAxios response:', response.data);
    return response.data;
  } catch (error) {
    // Обрабатываем сетевые ошибки (отсутствие интернета)
    if (handleNetworkError(error)) {
      throw new Error('Нет подключения к интернету');
    }

    // Для других ошибок
    // console.error('Error in PromoAxios:', error);
    throw error;
  }
};

export default checkPromoCode;
